<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex v-if="permissions.branches == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/Branches')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              الفروع
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.regions == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/Regions')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              المناطق</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.users == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/users')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              المستخدمين</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.client_users == 1 || user.type == 1"
          xs12
          sm6
          md3
        >
          <v-card
            @click="$router.push('/ClientUsers')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              المستخدمين العملاء</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.clients == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/clients')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />العملاء
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.importers == 1 || user.type == 1"
          xs12
          sm6
          md3
        >
          <v-card
            @click="$router.push('/importers')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              الموردين</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.stores == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/stores')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />المخازن</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.groups == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/groups')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />المجموعات
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.items == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/items')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              الاصناف
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.offers == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/OfferItems')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              العروض
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.khazinas == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/Khazina')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              الخزينة
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex v-if="permissions.banks == 1 || user.type == 1" xs12 sm6 md3>
          <v-card
            @click="$router.push('/Banks')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              البنوك</v-card-title
            >
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.masrofat_types == 1 || user.type == 1"
          xs12
          sm6
          md3
        >
          <v-card
            @click="$router.push('/Money')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />المصروفات</v-card-title
            >
          </v-card>
        </v-flex>
        <!--         
            <v-flex v-if="permissions.cars == 1 || user.type == 1"  xs12 sm6 md3>
            <v-card
            @click="$router.push('/Cars')"
            elevation="20"
                style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
                >
                
                    <v-card-title style="margin:auto;font-size:40px;font-weight: bold;" class="align-center fill-height justify-center"> <img style="width:40px;height:30px;margin:0 10px" src="../../../public/images/pharma_logo.jpg" alt="aa"> السيارات </v-card-title>
                
                </v-card>
            </v-flex> -->

        <v-flex
          v-if="permissions.store_employer_link == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/EmployerStore')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              ربط موظف بمخزن
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.store_item_start == 1 || user.type == 1"
          xs12
          sm6
          md3
        >
          <v-card
            @click="$router.push('/StoreItemStart')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              بداية أصناف</v-card-title
            >
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
